import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Image = ({
  className,
  image,
  src,
  alt,
  style,
  loading,
  objectPosition,
  objectFit,
  ...otherProps
}) => {
  const imgData = getImage(image?.localFile || image);
  const fallbackAlt = alt || image?.altText || src || "bilde";
  if (imgData) {
    return (
      <GatsbyImage
        className={className}
        imgClassName={className}
        style={style}
        imgStyle={style}
        image={imgData}
        alt={fallbackAlt}
        objectFit={objectFit}
        loading={loading || "lazy"}
        objectPosition={objectPosition || image?.focalPoint?.objectPosition}
        {...otherProps}
      />
    );
  }
  return (
    <img
      className={className}
      style={style}
      src={src}
      alt={fallbackAlt}
      {...otherProps}
    />
  );
};

export default Image;

Image.propTypes = {
  className: PropTypes.string,
  image: PropTypes.object,
  src: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.string,
  objectPosition: PropTypes.string,
  objectFit: PropTypes.string,
};
